import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { DialogAnimate } from "src/components/Animate";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import eyeOffFill from "@iconify-icons/eva/eye-off-fill";
import eyeFill from "@iconify-icons/eva/eye-fill";

import {
  Typography,
  Box,
  IconButton,
  Button,
  TextField,
  InputAdornment,
  Grid,
} from "@material-ui/core";
import { ArrowLeft, Close } from "@material-ui/icons";
import createAvatar from "src/utils/createAvatar";
import {
  GetAllEmployees,
  addAdminEmployee,
  changeEmployee,
  changeOpenEmployeeModal,
} from "src/redux/slices/employee";
import { useDispatch } from "src/redux/store";
import useAuth from "src/hooks/useAuth";
import { useSnackbar } from "notistack";
import axios from "src/utils/axios";
import { LoadingButton } from "@material-ui/lab";
import Calculator from "src/components/calculator";
import "./styles.css"; // Asegúrate de que la ruta sea correcta
import MyAutoSnack from "src/components/MyAutoSnack";
import { PATH_APP } from "src/routes/paths";
import { loginByPin, logoutEmployee } from "src/redux/slices/employeeSession";
import { getDeviceId } from "src/utils/deviceId";
import { postActionRoute } from "src/utils/postActionRoute";
import useResponsive from "src/hooks/useResponsive";
import { Avatar, Card, CardContent } from "@mui/material";
import IsRole from "src/utils/IsRole";
import navConfig from "../NavBar/config";
import useEmployeeTakeoverConfirm from "src/components/employeeTakeover/useEmployeeTakeoverConfirm";
import { openClockingIfDue } from "src/utils/clocking/clockingDue";

function ModalEmployee({ isOpen, onClose }) {
  const { confirmTakeover, takeoverDialog } = useEmployeeTakeoverConfirm();
  const { employees, currentActiveEmployee, openEmployeeModal } = useSelector(
    (state) => state.employees
  );
  const width = useResponsive("down", "sm");

  const [admin, setAdmin] = useState(false);
  const [employee, setEmployee] = useState(null);

  const { user } = useAuth();
  const userState = useSelector((state) => state.authJwt);
  const { displays } = useSelector((state) => state.displays);

  const dispatch = useDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [activeStep, setActiveStep] = useState(0);
  const [currentEmployee, setCurrentEmployee] = useState(null);

  const history = useHistory();
  const location = useLocation();

  const myRef = React.useRef({});

  const handleClose = () => {
    dispatch(changeOpenEmployeeModal(null));
    onClose();
  };

  useEffect(() => {
    const current = employees.find(
      (employee) => employee.id === currentActiveEmployee
    );

    if (current) {
      setCurrentEmployee(current);
      return;
    }

    let admin = employees.find((employee) => employee.isAdmin);
    if (!admin) {
      setCurrentEmployee({ ...user, isAdmin: true, working: true });
      return;
    }

    setCurrentEmployee(admin);
  }, [user, employees, currentActiveEmployee]);

  useEffect(() => {
    dispatch(GetAllEmployees());
  }, []);

  const handleConfirmPassoword = async () => {
    setIsLoading(true);

    if (password === user.accessCode) {
      window.localStorage.setItem("UserEmployeeId", 0);
      axios.defaults.headers.common.UserEmployeeId = 0;
      // Vuelve el dueño: se cierra la sesión del empleado (si no, su token
      // quedaba en localStorage y al recargar parecía un empleado activo).
      dispatch(logoutEmployee()).catch(() => {});

      dispatch(
        addAdminEmployee({
          id: 0,
          name: user?.displayName,
          isAdmin: true,
          working: true,
          isInUse: true,
        })
      );

      handleClose();
      return;
    }

    await axios
      .post(`Authentication/checkCredentials`, {
        email: user.email,
        password: password,
      })
      .then((response) => {
        window.localStorage.setItem("UserEmployeeId", 0);
        axios.defaults.headers.common.UserEmployeeId = 0;
        // Vuelve el dueño: se cierra la sesión del empleado (si no, su token
        // quedaba en localStorage y al recargar parecía un empleado activo).
        dispatch(logoutEmployee()).catch(() => {});

        dispatch(
          addAdminEmployee({
            id: 0,
            name: user?.displayName,
            isAdmin: true,
            working: true,
            isInUse: true,
          })
        );

        handleClose();
      })
      .catch((error) => {
        setPassword(null);

        if (myRef.current) {
          myRef.current.resetClickHandler(); // Reinicia la calculadora
        }

        MyAutoSnack(
          "error",
          "Contraseña incorrecta",
          enqueueSnackbar,
          closeSnackbar
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleConfirmEmployeePassword = async () => {
    // Backend valida el par (PIN, employeeId) — el hash del PIN no
    // viaja al front, así que ya no comparamos client-side. Regla:
    // "PIN es Password (TPV), nunca PasswordAccess (login web)".
    setIsLoading(true);
    try {
      const res = await dispatch(
        loginByPin(String(password || ""), getDeviceId(), employee.id),
      );
      if (res?.code === "AMBIGUOUS_PIN") {
        // No debería pasar — pasamos employeeId. Si aún así ocurre,
        // abortamos con snackbar en lugar de aplicar el cambio.
        MyAutoSnack(
          "error",
          "El PIN no ha podido validarse. Inténtalo de nuevo.",
          enqueueSnackbar,
          closeSnackbar,
        );
        setPassword(null);
        if (myRef.current) myRef.current.resetClickHandler();
        setIsLoading(false);
        return;
      }
    } catch (err) {
      const msg =
        err?.response?.data?.message
          || (typeof err === "string" ? err : null)
          || "PIN incorrecto";
      MyAutoSnack("error", msg, enqueueSnackbar, closeSnackbar);
      setPassword(null);
      if (myRef.current) myRef.current.resetClickHandler();
      setIsLoading(false);
      return; // NO aplicar cambio si el backend rechaza
    }

    // Backend OK — aplicar cambio local.
    setIsLoading(false);
    {
      dispatch(changeEmployee(employee.id));
      handleClose();
      window.localStorage.setItem("UserEmployeeId", employee.id);
      axios.defaults.headers.common.UserEmployeeId = employee.id;

      // Fichaje que toca al identificarse (entrada/salida): misma regla que
      // el kiosko y el dispositivo asignado (src/utils/clocking/clockingDue.js).
      openClockingIfDue({ dispatch, user, employee });

      if (
        location.pathname === PATH_APP.tpv.cartaCamarero ||
        location.pathname === PATH_APP.tuCarta.tpv
      )
        return;

      if (!user.requestUserIdentity) return;

      if (!location || !location?.pathname) return;

      const currentEmployee = employees.find((e) => e.id === employee.id);

      if (!currentEmployee) return;

      if (
        !currentEmployee ||
        !currentEmployee.roleNavegation ||
        !currentEmployee.roleNavegation.actions
      ) {
        return;
      }

      const permissions = currentEmployee.roleNavegation.actions.map(
        (a) => a.name
      );

      if (!permissions || !permissions.length) return;

      var routes = navConfig(
        user,
        userState.user.isOnlyTpv,
        permissions,
        displays.filter((u) => u.isActive)
      ).items.filter((i) => IsRole(i.roles, userState.claims.role));

      if (!routes) return;

      var route = routes
        ?.flatMap((r) => (r.items ? r.items : r))
        ?.find((r) => r.href === location.pathname);

      if (!route) {
        redirect();
        return;
      }

      if (!route.condition) {
        redirect();
      }
    }
  };

  const redirect = () => {
    history.push(postActionRoute(userState.user));
  };

  const handleAddAdmin = () => {
    return (
      <Box spacing={2} padding={2}>
        <TextField
          fullWidth
          value={password || ""}
          type={"text"}
          label="Password"
          name="admin-pass"
          focused={true}
          autoComplete="off"
          onChange={(e, v) => setPassword(e.target.value)}
          disabled={password?.length < 0}
          InputProps={{
            endAdornment: (
              <InputAdornment>
                <IconButton
                  onClick={() => {
                    setShowPassword(!showPassword);
                  }}
                  edge="end"
                >
                  <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                </IconButton>
              </InputAdornment>
            ),
            className: showPassword ? "" : "hide-password",
          }}
        />
        <LoadingButton
          sx={{ mt: 2 }}
          fullWidth
          size="large"
          type="button"
          pending={isLoading}
          variant="contained"
          onClick={handleConfirmPassoword}
        >
          Validar
        </LoadingButton>
      </Box>
    );
  };

  const ChangeValueCalculatorCallback = (password) => {
    setPassword(password);
  };

  const handlePasswordEmployee = () => {
    return (
      <Box spacing={2} padding={2}>
        <TextField
          fullWidth
          type={"text"}
          label="Password"
          name="employee-pass"
          autoComplete="off"
          value={password || ""}
          focused={true}
          onChange={(e, v) => setPassword(e.target.value)}
          disabled={password?.length < 0}
          InputProps={{
            endAdornment: (
              <InputAdornment>
                <IconButton
                  onClick={() => {
                    setShowPassword(!showPassword);
                  }}
                  edge="end"
                >
                  <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                </IconButton>
              </InputAdornment>
            ),
            className: showPassword ? "" : "hide-password",
          }}
        />

        <LoadingButton
          sx={{ mt: 2 }}
          fullWidth
          size="large"
          type="button"
          pending={isLoading}
          variant="contained"
          onClick={handleConfirmEmployeePassword}
        >
          Validar
        </LoadingButton>
      </Box>
    );
  };

  const putCreedentials = (e) => {
    return (
      <Grid container padding={2} spacing={2} justifyContent="center">
        {admin ? (
          <>
            {width && user.accessCode !== "" ? (
              <>
                <Grid item xs={12} sx={{ mb: 2 }}>
                  <Button
                    onClick={() => {
                      setAdmin(false);
                      setEmployee(null);
                      setPassword(null);
                      setActiveStep(0);
                    }}
                    startIcon={<ArrowLeft />}
                    variant="contained"
                    size="large"
                    color="info"
                  >
                    Cambiar usuario
                  </Button>
                </Grid>

                <Grid item xs={12}>
                  {handleAddAdmin()}
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} sm={7}>
                  <Grid item xs={12} sx={{ mb: 2 }}>
                    <Button
                      onClick={() => {
                        setAdmin(false);
                        setEmployee(null);
                        setPassword(null);
                        setActiveStep(0);
                      }}
                      startIcon={<ArrowLeft />}
                      variant="contained"
                      size="large"
                      color="info"
                    >
                      Cambiar usuario
                    </Button>
                  </Grid>

                  <Grid item xs={12}>
                    {handleAddAdmin()}
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={5}>
                  <Calculator
                    callback={ChangeValueCalculatorCallback}
                    ref={myRef}
                    justNumber={true}
                  />
                </Grid>
              </>
            )}
          </>
        ) : (
          <>
            {width ? (
              <>
                <Grid item xs={12} sx={{ mb: 2 }}>
                  <Button
                    onClick={() => {
                      setAdmin(false);
                      setEmployee(null);
                      setPassword(null);
                      setActiveStep(0);
                    }}
                    startIcon={<ArrowLeft />}
                    variant="contained"
                    size="large"
                    color="info"
                  >
                    Cambiar usuario
                  </Button>
                </Grid>

                <Grid item xs={12}>
                  {handlePasswordEmployee()}
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} sm={5}>
                  <Grid item xs={12} sx={{ mb: 2 }}>
                    <Button
                      onClick={() => {
                        setAdmin(false);
                        setEmployee(null);
                        setPassword(null);
                        setActiveStep(0);
                      }}
                      startIcon={<ArrowLeft />}
                      variant="contained"
                      size="large"
                      color="info"
                    >
                      Cambiar usuario
                    </Button>
                  </Grid>

                  <Grid item xs={12}>
                    {handlePasswordEmployee()}
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={7}>
                  <Calculator
                    callback={ChangeValueCalculatorCallback}
                    ref={myRef}
                    justNumber={true}
                  />
                </Grid>
              </>
            )}
          </>
        )}
      </Grid>
    );
  };

  const listEmployees = () => {
    return (
      <Grid container spacing={3}>
        {/* Card para el administrador */}
        {((openEmployeeModal?.isManual && currentActiveEmployee !== 0) ||
          !openEmployeeModal?.isManual) && (
          <Grid item xs={6} sm={6} md={4}>
            <Card
              sx={{
                borderRadius: 2,
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                border:
                  currentEmployee && currentEmployee.id === 0
                    ? "2px solid #1976d2"
                    : "none",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 6px 15px rgba(0, 0, 0, 0.2)",
                },
              }}
              onClick={() => {
                setAdmin(true);
                setEmployee(null);
                setPassword(null);
                setActiveStep(1);
              }}
            >
              <CardContent sx={{ textAlign: "center", padding: "20px" }}>
                <Avatar
                  sx={{
                    width: 64,
                    height: 64,
                    margin: "0 auto",
                    backgroundColor: createAvatar(user?.displayName).color,
                  }}
                  src={user?.displayName}
                  alt={user?.displayName}
                >
                  {createAvatar(user?.displayName).name}
                </Avatar>
                <Typography variant="h6" mt={2} color="text.primary">
                  {user.displayName} (Admin)
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Administrador del sistema
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        )}

        {/* Cards para los empleados */}
        {employees
          .filter((e) => e.isActive)
          .filter((e) => !e.isAdmin)
          .filter((e) => {
            if (!openEmployeeModal?.isManual) return true;

            return e.id !== currentActiveEmployee;
          })
          .map((e) => (
            <Grid item xs={6} sm={6} md={4} key={e.id}>
              <Card
                sx={{
                  borderRadius: 2,
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                  border:
                    currentEmployee && currentEmployee.id === e.id
                      ? "2px solid #1976d2"
                      : "none",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 6px 15px rgba(0, 0, 0, 0.2)",
                  },
                }}
                onClick={async () => {
                  if (employee && employee.id === e.id) setEmployee(null);
                  else {
                    // 2026-10-06 · En uso en otro dispositivo → aviso antes.
                    if (!(await confirmTakeover(e))) return;
                    setAdmin(false);

                    if (e.password) {
                      setEmployee(e);
                    } else {
                      window.localStorage.setItem("UserEmployeeId", e.id);
                      axios.defaults.headers.common.UserEmployeeId = e.id;
                      dispatch(changeEmployee(e.id));
                      onClose();
                    }
                  }
                  setPassword(null);
                  setActiveStep(1);
                }}
              >
                <CardContent sx={{ textAlign: "center", padding: "20px" }}>
                  <Avatar
                    sx={{
                      width: 64,
                      height: 64,
                      margin: "0 auto",
                      backgroundColor: createAvatar(e.name).color,
                    }}
                    src={e?.avatar}
                    alt={e?.name}
                  >
                    {createAvatar(e.name).name}
                  </Avatar>
                  <Typography variant="h6" mt={2} color="text.primary">
                    {e.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Empleado activo
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
      </Grid>
    );
  };

  return (
    <DialogAnimate open={isOpen} key="Modal Employee" maxWidth={"lg"}>
      {takeoverDialog}
      <Box sx={{ p: 4, textAlign: "center" }}>
        {openEmployeeModal?.isManual && (
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        )}

        <Box sx={{ my: 2 }}>
          <Typography variant="h6">
            {activeStep === 0
              ? "Selecciona tu usuario"
              : `Introduce tu contraseña`}
          </Typography>
        </Box>
        <Box>
          {activeStep === 0 && listEmployees()}
          {activeStep === 1 && putCreedentials()}
        </Box>
      </Box>
    </DialogAnimate>
  );
}

export default ModalEmployee;
